import { render, staticRenderFns } from "./BigCard.vue?vue&type=template&id=3a7b787d&scoped=true"
import script from "./BigCard.vue?vue&type=script&lang=js"
export * from "./BigCard.vue?vue&type=script&lang=js"
import style0 from "./BigCard.vue?vue&type=style&index=0&id=3a7b787d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a7b787d",
  null
  
)

export default component.exports